import { render, staticRenderFns } from "./WebsiteTagTable.vue?vue&type=template&id=e631a88a&scoped=true&"
import script from "./WebsiteTagTable.vue?vue&type=script&lang=js&"
export * from "./WebsiteTagTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e631a88a",
  null
  
)

export default component.exports